export const mapErrors = {
    unmatchedNode: "The node for which to show this element could not be matched with the provided coordinate",
};

export enum ValidationError {
    POLYGON_FEW_NODES = "POLYGON_FEW_NODES",
    LINESTRING_FEW_NODES = "LINESTRING_FEW_NODES",
    MAP_OBJECT_COPY_LIMIT_EXCEEDED = "MAP_OBJECT_COPY_LIMIT_EXCEEDED",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
}
